import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  fade,
  ListItem,
  ListItemText,
  useTheme,
  withStyles,
} from "@material-ui/core";
import { ActivityListItemAvatar } from "./ActivityListItemAvatar";
import { formatActivityItemDate } from "../utils/activities";

const InteractiveListItem = withStyles((theme) => ({
  button: {
    "&:hover": {
      backgroundColor: fade(theme.palette.primary.main, 0.04),
    },
    "&$selected, &:focus": {
      backgroundColor: fade(theme.palette.primary.main, 0.08),
    },
  },
  selected: {},
}))(ListItem) as typeof ListItem;

export const ActivityListItem: React.FC<{
  icon: React.ReactNode;
  title: string | React.ReactNode;
  activityDttm?: string | null;
  linkTo?: string;
  isPending?: boolean;
}> = ({ icon, title, activityDttm, linkTo, isPending }) => {
  const theme = useTheme();
  const { pathname } = useLocation();

  const content = (
    <>
      <ActivityListItemAvatar isPending={!!isPending}>
        {icon}
      </ActivityListItemAvatar>
      <ListItemText
        data-testid="ActivityPanel__ListItemText"
        primary={title}
        secondary={activityDttm ? formatActivityItemDate(activityDttm) : null}
        primaryTypographyProps={{
          variant: "body2",
        }}
        secondaryTypographyProps={{
          variant: "caption",
          display: "block",
          color: "textSecondary",
        }}
      />
    </>
  );

  return linkTo ? (
    <InteractiveListItem
      data-testid="ActivityPanel__ListItem"
      button
      TouchRippleProps={{
        style: {
          color: theme.palette.primary.main,
        },
      }}
      selected={linkTo === pathname}
      component={Link}
      to={linkTo}
    >
      {content}
    </InteractiveListItem>
  ) : (
    <ListItem data-testid="ActivityPanel__ListItem" component="div">
      {content}
    </ListItem>
  );
};
